import {
  fetchBedTypes,
  fetchMealTypes,
  fetchRoomOptions,
  fetchRoomTypes,
} from "@services/api/configApi";
import { useEffect, useState } from "react";

const useRoomConfig = () => {
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomOptions, setRoomOptions] = useState([]);
  const [mealTypes, setMealTypes] = useState([]);
  const [bedTypes, setBedTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        setLoading(true);

        const [roomTypesData, roomOptionsData, mealTypesData, bedTypesData] =
          await Promise.all([
            fetchRoomTypes(),
            fetchRoomOptions(),
            fetchMealTypes(),
            fetchBedTypes(),
          ]);

        setRoomTypes([
          { title: "", value: null },
          ...(roomTypesData || []).map((item) => ({
            title: item.name || item.title || `Room Type ${item.id}`,
            value: item.id,
          })),
          { title: "Autre", value: "0" },
        ]);

        setRoomOptions([
          { title: "", value: null },
          ...(roomOptionsData || []).map((item) => ({
            title: item.name || item.title || `Room Option ${item.id}`,
            value: item.id,
          })),
          { title: "Autre", value: "0" },
        ]);

        setMealTypes([
          { title: "", value: null },
          ...(mealTypesData || []).map((item) => ({
            title: item.name || item.title || `Meal Type ${item.id}`,
            value: item.id,
          })),
        ]);

        setBedTypes([{ title: "", value: null }, ...bedTypesData]);
      } catch (err) {
        console.error("Error loading room config:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  // Function to add a new room type (called after API success)
  const addRoomType = (newRoomTypeName, newRoomTypeId) => {
    // Create the new room type object with the REAL ID from API
    const newRoomType = {
      title: newRoomTypeName,
      value: newRoomTypeId,
    };
    
    // Add the new room type before the "Autre" option
    setRoomTypes(prevRoomTypes => {
      const otherOption = prevRoomTypes[prevRoomTypes.length - 1];
      const optionsWithoutOther = prevRoomTypes.slice(0, -1);
      return [...optionsWithoutOther, newRoomType, otherOption];
    });
  };
  
  // Function to add a new room option (called after API success)
  const addRoomOption = (newRoomOptionName, newRoomOptionId) => {
    const newRoomOption = {
      title: newRoomOptionName,
      value: newRoomOptionId,
    };
    
    setRoomOptions(prevRoomOptions => {
      const otherOption = prevRoomOptions[prevRoomOptions.length - 1];
      const optionsWithoutOther = prevRoomOptions.slice(0, -1);
      return [...optionsWithoutOther, newRoomOption, otherOption];
    });
  };

  return { 
    roomTypes, 
    roomOptions, 
    mealTypes, 
    bedTypes, 
    loading, 
    error, 
    addRoomType,
    addRoomOption 
  };
};

export default useRoomConfig;